<script>
    import Subsection from "./Subsection.svelte";

    export let section;
</script>

<div class="section">
    <div class="title">
        {section.title}
    </div>
    <div class="section-content">
        {#each section.subsections as subsection (subsection.title)}
            <Subsection {subsection}/>
        {/each}
    </div>
</div>

<style>
    .section {
        padding: .5rem;
        margin-bottom: 1.5em;
    }

    .section > .title {
        font-weight: bold;
        font-size: 1.3rem;
        margin-bottom: .5em;
    }

    .section-content {
        display: flex;
        flex-wrap: wrap;
        padding: .5em;
    }

</style>